import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.5);
  display: grid;
  place-items: center;
  z-index: 1000;
  padding: 16px;
`;

export const ModalCard = styled.div`
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.2);
  padding: 18px;
`;

export const ModalTitle = styled.h4`
  margin: 4px 0 10px;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
`;

export const ModalDesc = styled.p`
  margin: 0 0 14px;
  font-size: 13px;
  color: #334155;
  line-height: 1.5;
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const ModalBtn = styled.button<{ $danger?: boolean }>`
  min-width: 86px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: ${(p) => (p.$danger ? "#22c55e" : "#ffffff")};
  color: ${(p) => (p.$danger ? "#fff" : "#0f172a")};
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.15s ease, background 0.15s ease,
    border-color 0.15s ease, opacity 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
    background: ${(p) => (p.$danger ? "#16a34a" : "#f8fafc")};
    border-color: #cbd5e1;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

/* ==== 입력 필드 (confirmMessage 있을 때만 노출) ==== */
export const ModalInputWrap = styled.div`
  display: grid;
  gap: 8px;
  margin: 8px 0 4px;
`;

export const ModalLabel = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: #334155;
`;

export const ModalInput = styled.input`
  height: 36px;
  border-radius: 10px;
  padding: 0 12px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background 0.15s ease;

  &:focus {
    outline: 0;
    border-color: #93c5fd;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
    background: #ffffff;
  }

  &[aria-invalid="true"] {
    border-color: #fecaca;
  }
`;

export const ModalHint = styled.p<{ $invalid?: boolean }>`
  margin: 0;
  font-size: 12px;
  color: ${(p) => (p.$invalid ? "#b91c1c" : "#64748b")};

  b {
    font-weight: 800;
    color: ${(p) => (p.$invalid ? "#991b1b" : "#0f172a")};
  }
`;
